(function () {
  "use strict";

  var VIEWBOX_SIZE = 800;
  var DEFAULT_BORDER_IN = 0.08;
  var DEFAULT_GAP_IN = 0.09;
  var TAB_COMPOSITION_REF_WIDTH_IN = 2.0;
  var TAB_WIDTH_IN = 0.16;
  var TAB_HEIGHT_IN = 0.25;
  var PAPER_CDN = "https://unpkg.com/paper@0.12.17/dist/paper-full.min.js";

  var _paperReady = false;
  var _paperPromise = null;

  function ensurePaper() {
    if (window.paper && _paperReady) return Promise.resolve();
    if (_paperPromise) return _paperPromise;
    _paperPromise = new Promise(function (resolve, reject) {
      if (window.paper) {
        _setupPaper();
        resolve();
        return;
      }
      var script = document.createElement("script");
      script.src = PAPER_CDN;
      script.onload = function () {
        _setupPaper();
        resolve();
      };
      script.onerror = function () {
        _paperPromise = null;
        reject(new Error("[ZUG][ACRYLIC_GEO] Failed to load Paper.js"));
      };
      document.head.appendChild(script);
    });
    return _paperPromise;
  }

  function _setupPaper() {
    if (_paperReady) return;
    var c = document.createElement("canvas");
    c.width = VIEWBOX_SIZE;
    c.height = VIEWBOX_SIZE;
    window.paper.setup(c);
    _paperReady = true;
    console.log("[ZUG][ACRYLIC_GEO] Paper.js ready");
  }

  function _collectPaperPaths(item, out) {
    out = out || [];
    if (!item) return out;
    if (
      item instanceof window.paper.Path ||
      item instanceof window.paper.CompoundPath
    ) {
      out.push(item);
    } else if (item.children) {
      for (var i = 0; i < item.children.length; i++) {
        _collectPaperPaths(item.children[i], out);
      }
    }
    return out;
  }

  function _buildMergedTabPath(bodyPathD, _unused_bbox, tabConfig, physicalWidthIn) {
    var p = window.paper;
    var svgStr =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' +
      VIEWBOX_SIZE +
      " " +
      VIEWBOX_SIZE +
      '"><path d="' +
      bodyPathD +
      '" fill="black"/></svg>';

    p.project.clear();
    var item = p.project.importSVG(svgStr, { insert: false });
    var paths = _collectPaperPaths(item);

    if (!paths.length) {
      console.warn("[ZUG][ACRYLIC_GEO] No paths found for tab merge");
      return null;
    }

    var mergedBody = paths[0].clone({ insert: false });
    mergedBody.closed = true;
    mergedBody.fillColor = "black";

    for (var i = 1; i < paths.length; i++) {
      var next = paths[i].clone({ insert: false });
      next.closed = true;
      next.fillColor = "black";
      var unioned = mergedBody.unite(next, { insert: false });
      mergedBody.remove();
      next.remove();
      mergedBody = unioned;
    }

    var bodyBounds = mergedBody.bounds;
    var bbox = {
      x: bodyBounds.x,
      y: bodyBounds.y,
      width: bodyBounds.width,
      height: bodyBounds.height
    };

    var actualWidthIn = (physicalWidthIn > 0) ? physicalWidthIn : TAB_COMPOSITION_REF_WIDTH_IN;
    var vbPerInch = bbox.width / actualWidthIn;
    var tabWidth = TAB_WIDTH_IN * vbPerInch;
    var tabHeight = TAB_HEIGHT_IN * vbPerInch;
    var tabDomeRadius = tabWidth / 2;
    var stemVisibleHeight = Math.max(0, tabHeight - tabDomeRadius);
    var stemOverlap = tabDomeRadius * 0.35;
    var holeRadius = tabWidth * tabConfig.holeRatio;
    var centerX = bbox.x + bbox.width / 2;

    var domeCenterY = bbox.y - stemVisibleHeight;
    var stemTop = domeCenterY;
    var stemBottom = bbox.y + stemOverlap;

    console.log('[ZUG][ACRYLIC_GEO] tab vbPerInch=' + vbPerInch.toFixed(2) + ' (physW=' + actualWidthIn + '") → tabVB: ' + tabWidth.toFixed(1) + 'x' + tabHeight.toFixed(1));
    console.log('[ZUG][ACRYLIC_GEO] tab totalH=' + TAB_HEIGHT_IN + '" domeR=' + (TAB_WIDTH_IN/2).toFixed(3) + '" stemVisible=' + (TAB_HEIGHT_IN - TAB_WIDTH_IN/2).toFixed(3) + '" overlap=' + (TAB_WIDTH_IN/2*0.35).toFixed(3) + '"');

    var stemRect = new p.Path.Rectangle(
      new p.Rectangle(
        new p.Point(centerX - tabWidth / 2, stemTop),
        new p.Point(centerX + tabWidth / 2, stemBottom)
      )
    );
    stemRect.fillColor = "black";

    var dome = new p.Path.Circle(
      new p.Point(centerX, domeCenterY),
      tabDomeRadius
    );
    dome.fillColor = "black";

    var tab = stemRect.unite(dome, { insert: false });
    stemRect.remove();
    dome.remove();

    var merged = mergedBody.unite(tab, { insert: false });
    mergedBody.remove();
    tab.remove();

    var holeCx = centerX;
    var holeCy = domeCenterY;

    merged.fillColor = "black";
    merged.strokeColor = null;
    merged.applyMatrix = true;
    merged.flatten(0.25);
    var outerPathData = merged.pathData;

    var hole = new p.Path.Circle(
      new p.Point(holeCx, holeCy),
      holeRadius
    );
    hole.fillColor = "black";
    var finalShape = merged.subtract(hole, { insert: false });
    merged.remove();
    hole.remove();

    finalShape.fillColor = "black";
    finalShape.strokeColor = null;
    finalShape.applyMatrix = true;
    finalShape.flatten(0.25);

    var pathData = finalShape.pathData;
    var b = finalShape.bounds;
    var bounds = { x: b.x, y: b.y, width: b.width, height: b.height };
    finalShape.remove();

    console.log("[ZUG][ACRYLIC_GEO] tab merge complete (FIXED INCH: " + TAB_WIDTH_IN + '"x' + TAB_HEIGHT_IN + '")', {
      tabWidthVB: tabWidth.toFixed(1),
      tabHeightVB: tabHeight.toFixed(1),
      tabWidthIn: TAB_WIDTH_IN,
      tabHeightIn: TAB_HEIGHT_IN,
      domeCenterY: domeCenterY.toFixed(1),
      stemOverlap: stemOverlap.toFixed(1),
      stemBottom: stemBottom.toFixed(1),
      bodyTopY: bbox.y.toFixed(1),
      holeRadius: holeRadius.toFixed(1),
      holeCx: holeCx.toFixed(1),
      holeCy: holeCy.toFixed(1),
      bodyBbox: JSON.stringify(bbox),
      mergedBounds: JSON.stringify(bounds),
    });

    return {
      pathData: pathData,
      outerPathData: outerPathData,
      bounds: bounds,
      bodyBbox: bbox,
      hole: { cx: holeCx, cy: holeCy, r: holeRadius },
    };
  }

  function pathBBox(d) {
    if (!d) return null;
    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox", "0 0 " + VIEWBOX_SIZE + " " + VIEWBOX_SIZE);
    svg.style.cssText = "position:absolute;width:0;height:0;overflow:hidden;";
    var p = document.createElementNS("http://www.w3.org/2000/svg", "path");
    p.setAttribute("d", d);
    svg.appendChild(p);
    document.body.appendChild(svg);
    var box;
    try {
      box = p.getBBox();
    } catch (e) {
      box = { x: 0, y: 0, width: VIEWBOX_SIZE, height: VIEWBOX_SIZE };
    }
    document.body.removeChild(svg);
    return { x: box.x, y: box.y, width: box.width, height: box.height };
  }

  function svgToDataUri(svgText) {
    return (
      'url("data:image/svg+xml,' + encodeURIComponent(svgText.trim()) + '")'
    );
  }

  function expandBounds(bounds, expansion) {
    return {
      x: bounds.x - expansion,
      y: bounds.y - expansion,
      width: bounds.width + expansion * 2,
      height: bounds.height + expansion * 2
    };
  }

  function generateShapes(bodyPathD, subtype, options) {
    options = options || {};
    var bbox = pathBBox(bodyPathD);
    if (!bbox) {
      console.warn("[ZUG][ACRYLIC_GEO] Cannot compute bbox for body path");
      return { fallback: true };
    }

    var borderIn = options.borderIn || DEFAULT_BORDER_IN;
    var gapIn = options.gapIn || DEFAULT_GAP_IN;

    var physicalWidthIn = options.physicalWidthIn || 0;
    var physicalHeightIn = options.physicalHeightIn || 0;

    var outlineWidth = options.outlineWidth || 1.15;
    var outlineOpacity = options.outlineOpacity || 0.34;

    var hasTab =
      options.has_tab && options.tabConfig && window.paper && _paperReady;
    var outerPathD = bodyPathD;
    var tabMergedBounds = null;
    var tabHole = null;
    var tabOuterPathD = null;

    if (hasTab) {
      var tabResult = _buildMergedTabPath(bodyPathD, bbox, options.tabConfig, physicalWidthIn);
      if (tabResult) {
        outerPathD = tabResult.pathData;
        tabOuterPathD = tabResult.outerPathData;
        tabMergedBounds = tabResult.bounds;
        tabHole = tabResult.hole;
        if (tabResult.bodyBbox) {
          bbox = tabResult.bodyBbox;
        }
      }
    }

    var vbPerInch;
    var vbPerInchSource;
    if (physicalWidthIn > 0 && physicalHeightIn > 0) {
      var bodyVBPerInchX = bbox.width / physicalWidthIn;
      var bodyVBPerInchY = bbox.height / physicalHeightIn;
      vbPerInch = Math.max(bodyVBPerInchX, bodyVBPerInchY);
      vbPerInchSource = 'body-bbox(' + physicalWidthIn.toFixed(3) + 'x' + physicalHeightIn.toFixed(3) + ')';
      console.log('[ZUG][ACRYLIC_GAP] bodyVBPerInchX=' + bodyVBPerInchX.toFixed(2));
      console.log('[ZUG][ACRYLIC_GAP] bodyVBPerInchY=' + bodyVBPerInchY.toFixed(2));
      console.log('[ZUG][ACRYLIC_GAP] chosen bodyVBPerInch=' + vbPerInch.toFixed(2));
    } else if (physicalWidthIn > 0) {
      vbPerInch = bbox.width / physicalWidthIn;
      vbPerInchSource = 'body-width(' + physicalWidthIn.toFixed(3) + ')';
    } else {
      vbPerInch = Math.max(bbox.width, bbox.height) / 1.5;
      vbPerInchSource = 'fallback';
      console.warn(
        "[ZUG][ACRYLIC_GEO] No physical dims, fallback vbPerInch=" +
          vbPerInch.toFixed(1),
      );
    }

    var printExpansionIn = borderIn;
    var clearBorderIn = gapIn;
    var outerExpansionIn = printExpansionIn + clearBorderIn;
    var printExpansionVB = printExpansionIn * vbPerInch;
    var outerExpansionVB = outerExpansionIn * vbPerInch;
    var printStrokeW = printExpansionVB * 2;
    var outerStrokeW = outerExpansionVB * 2;
    var printBbox = expandBounds(bbox, printExpansionVB);
    var cutBbox = expandBounds(tabMergedBounds || bbox, outerExpansionVB);
    console.log('[ZUG][ACRYLIC_GAP] printExpansionVB=' + printExpansionVB.toFixed(2));
    console.log('[ZUG][ACRYLIC_GAP] outerExpansionVB=' + outerExpansionVB.toFixed(2));
    console.log('[ZUG][ACRYLIC_GAP] clearBorder=' + clearBorderIn.toFixed(3) + '" = ' + (outerExpansionVB - printExpansionVB).toFixed(2) + ' VB per side');
    console.log('[ZUG][ACRYLIC_GAP] outer/print ratio=' + (outerExpansionVB / printExpansionVB).toFixed(4));

    if (tabMergedBounds) {
      var expandPad = outerStrokeW + 4;
      var tabTopExtension = bbox.y - tabMergedBounds.y;
      var bodyBottom = bbox.y + bbox.height;
      var mergedBottom = tabMergedBounds.y + tabMergedBounds.height;
      var bottomExtra = Math.max(0, tabTopExtension - (mergedBottom - bodyBottom));
      var vbX = tabMergedBounds.x - expandPad;
      var vbY = tabMergedBounds.y - expandPad;
      var vbW = tabMergedBounds.width + expandPad * 2;
      var vbH = tabMergedBounds.height + expandPad * 2 + bottomExtra;
      var vb = vbX.toFixed(2) + " " + vbY.toFixed(2) + " " + vbW.toFixed(2) + " " + vbH.toFixed(2);

      var strokePathD = tabOuterPathD || outerPathD;

      var printMaskSvg =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' +
        vb +
        '">' +
        '<path d="' +
        bodyPathD +
        '" fill="white" stroke="white" stroke-width="' +
        printStrokeW.toFixed(2) +
        '" stroke-linejoin="round" stroke-linecap="round" paint-order="stroke fill"/>' +
        "</svg>";

      var holeCutout = "";
      if (tabHole) {
        holeCutout =
          '<circle cx="' + tabHole.cx.toFixed(2) +
          '" cy="' + tabHole.cy.toFixed(2) +
          '" r="' + (tabHole.r + outerExpansionVB * 0.15).toFixed(2) +
          '" fill="black"/>';
      }

      var outerMaskSvg =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' +
        vb +
        '">' +
        '<mask id="acr-hole-cut">' +
        '<rect x="' + vbX.toFixed(2) + '" y="' + vbY.toFixed(2) +
        '" width="' + vbW.toFixed(2) + '" height="' + vbH.toFixed(2) + '" fill="white"/>' +
        holeCutout +
        "</mask>" +
        '<path d="' +
        strokePathD +
        '" fill="white" stroke="white" stroke-width="' +
        outerStrokeW.toFixed(2) +
        '" stroke-linejoin="round" stroke-linecap="round" paint-order="stroke fill" mask="url(#acr-hole-cut)"/>' +
        "</svg>";

      var tabRingWidth = outlineWidth * 2.5;
      var outlineHoleCircle = "";
      if (tabHole) {
        outlineHoleCircle =
          '<circle cx="' + tabHole.cx.toFixed(2) +
          '" cy="' + tabHole.cy.toFixed(2) +
          '" r="' + tabHole.r.toFixed(2) +
          '" fill="none" stroke="rgba(109, 121, 135, ' +
          outlineOpacity.toFixed(2) +
          ')" stroke-width="' + tabRingWidth.toFixed(2) + '"/>';
      }

      var outlineSvg =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' +
        vb +
        '" style="width:100%;height:100%;display:block;">' +
        '<defs><mask id="acr-ring">' +
        '<rect x="' + vbX.toFixed(2) + '" y="' + vbY.toFixed(2) +
        '" width="' + vbW.toFixed(2) + '" height="' + vbH.toFixed(2) + '" fill="white"/>' +
        '<path d="' +
        strokePathD +
        '" fill="black" stroke="black" stroke-width="' +
        outerStrokeW.toFixed(2) +
        '" stroke-linejoin="round" stroke-linecap="round" paint-order="stroke fill"/>' +
        "</mask></defs>" +
        '<path d="' +
        strokePathD +
        '" fill="none" stroke="rgba(109, 121, 135, ' +
        outlineOpacity.toFixed(2) +
        ')" stroke-width="' +
        (outerStrokeW + tabRingWidth * 2).toFixed(2) +
        '" stroke-linejoin="round" stroke-linecap="round" paint-order="stroke fill" mask="url(#acr-ring)"/>' +
        outlineHoleCircle +
        "</svg>";

      var printBounds = printBbox;
      var holeAnchor = null;
      if (tabHole) {
        holeAnchor = {
          xPct: (tabHole.cx - vbX) / vbW * 100,
          yPct: (tabHole.cy - vbY) / vbH * 100,
          rPctW: tabHole.r / vbW * 100,
          rPctH: tabHole.r / vbH * 100,
          cx: tabHole.cx,
          cy: tabHole.cy,
          r: tabHole.r
        };
      }

      var outerBbox = {
        x: vbX,
        y: vbY,
        width: vbW,
        height: vbH,
      };

      console.log("[ZUG][ACRYLIC_GEO] === TAB COMPOSITION DEBUG (physW=" + physicalWidthIn.toFixed(2) + '") ===');
      console.log("[ZUG][ACRYLIC_GEO]   vbPerInch: " + vbPerInch.toFixed(4) + " source=" + vbPerInchSource);
      console.log("[ZUG][ACRYLIC_GEO]   bodyBbox: {x:" + bbox.x.toFixed(2) + " y:" + bbox.y.toFixed(2) + " w:" + bbox.width.toFixed(2) + " h:" + bbox.height.toFixed(2) + "}");
      console.log("[ZUG][ACRYLIC_GEO]   mergedBounds: {x:" + tabMergedBounds.x.toFixed(2) + " y:" + tabMergedBounds.y.toFixed(2) + " w:" + tabMergedBounds.width.toFixed(2) + " h:" + tabMergedBounds.height.toFixed(2) + "}");
      console.log("[ZUG][ACRYLIC_GEO]   tabTopExtension: " + tabTopExtension.toFixed(2) + " bottomExtra: " + bottomExtra.toFixed(2) + " (body-centering pad)");
      console.log("[ZUG][ACRYLIC_GEO]   expandedVB: {x:" + vbX.toFixed(2) + " y:" + vbY.toFixed(2) + " w:" + vbW.toFixed(2) + " h:" + vbH.toFixed(2) + "}");
      console.log("[ZUG][ACRYLIC_GEO]   printBounds: {x:" + printBounds.x.toFixed(2) + " y:" + printBounds.y.toFixed(2) + " w:" + printBounds.width.toFixed(2) + " h:" + printBounds.height.toFixed(2) + "}");
      console.log("[ZUG][ACRYLIC_GEO]   aspectRatio: " + vbW.toFixed(2) + " / " + vbH.toFixed(2));
      if (tabHole) {
        console.log("[ZUG][ACRYLIC_GEO]   hole: {cx:" + tabHole.cx.toFixed(2) + " cy:" + tabHole.cy.toFixed(2) + " r:" + tabHole.r.toFixed(2) + "} (FIXED)");
      }
      if (holeAnchor) {
        console.log("[ZUG][ACRYLIC_GEO]   holeAnchor: {x:" + holeAnchor.xPct.toFixed(4) + "% y:" + holeAnchor.yPct.toFixed(4) + "%} (FIXED)");
      }

      var debugOverlaySvg =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' + vb +
        '" style="width:100%;height:100%;display:block;overflow:visible;">' +
        '<path d="' + strokePathD + '" fill="none" stroke="blue" stroke-width="2" stroke-dasharray="6,3" opacity="0.8"/>' +
        '<path d="' + bodyPathD + '" fill="none" stroke="red" stroke-width="2" opacity="0.9"/>' +
        '<path d="' + bodyPathD + '" fill="none" stroke="green" stroke-width="' + printStrokeW.toFixed(2) + '" stroke-linejoin="round" stroke-linecap="round" paint-order="stroke fill" opacity="0.35"/>' +
        '<path d="' + strokePathD + '" fill="none" stroke="blue" stroke-width="' + outerStrokeW.toFixed(2) + '" stroke-linejoin="round" stroke-linecap="round" paint-order="stroke fill" opacity="0.2"/>' +
        '<rect x="' + bbox.x.toFixed(2) + '" y="' + bbox.y.toFixed(2) + '" width="' + bbox.width.toFixed(2) + '" height="' + bbox.height.toFixed(2) + '" fill="none" stroke="red" stroke-width="1" stroke-dasharray="4,2" opacity="0.6"/>' +
        '<circle cx="' + (bbox.x + bbox.width / 2).toFixed(2) + '" cy="' + (bbox.y + bbox.height / 2).toFixed(2) + '" r="4" fill="red" opacity="0.7"/>' +
        '<rect x="' + printBounds.x.toFixed(2) + '" y="' + printBounds.y.toFixed(2) + '" width="' + printBounds.width.toFixed(2) + '" height="' + printBounds.height.toFixed(2) + '" fill="none" stroke="cyan" stroke-width="1.5" stroke-dasharray="8,4" opacity="0.7"/>' +
        '<circle cx="' + (printBounds.x + printBounds.width / 2).toFixed(2) + '" cy="' + (printBounds.y + printBounds.height / 2).toFixed(2) + '" r="3" fill="cyan" opacity="0.7"/>' +
        '<rect x="0" y="0" width="' + VIEWBOX_SIZE + '" height="' + VIEWBOX_SIZE + '" fill="none" stroke="orange" stroke-width="1" stroke-dasharray="8,4" opacity="0.3"/>' +
        '</svg>';

      var printExpandedBbox = printBbox;

      console.log("[ZUG][ACRYLIC_GEO] === DEBUG BOUNDS ===");
      console.log("[ZUG][ACRYLIC_GEO] bodyPath (red):  x=" + bbox.x.toFixed(2) + " y=" + bbox.y.toFixed(2) + " w=" + bbox.width.toFixed(2) + " h=" + bbox.height.toFixed(2) + " cx=" + (bbox.x + bbox.width / 2).toFixed(2) + " cy=" + (bbox.y + bbox.height / 2).toFixed(2));
      if (printExpandedBbox) {
        console.log("[ZUG][ACRYLIC_GEO] printPath (green): x=" + printExpandedBbox.x.toFixed(2) + " y=" + printExpandedBbox.y.toFixed(2) + " w=" + printExpandedBbox.width.toFixed(2) + " h=" + printExpandedBbox.height.toFixed(2) + " cx=" + (printExpandedBbox.x + printExpandedBbox.width / 2).toFixed(2) + " cy=" + (printExpandedBbox.y + printExpandedBbox.height / 2).toFixed(2));
      }
      console.log("[ZUG][ACRYLIC_GEO] outerPath (blue): x=" + tabMergedBounds.x.toFixed(2) + " y=" + tabMergedBounds.y.toFixed(2) + " w=" + tabMergedBounds.width.toFixed(2) + " h=" + tabMergedBounds.height.toFixed(2) + " cx=" + (tabMergedBounds.x + tabMergedBounds.width / 2).toFixed(2) + " cy=" + (tabMergedBounds.y + tabMergedBounds.height / 2).toFixed(2));
      console.log("[ZUG][ACRYLIC_GEO] 800x800 canvas (orange): x=0 y=0 w=800 h=800 cx=400 cy=400");
      console.log("[ZUG][ACRYLIC_GEO] expandedVB: x=" + vbX.toFixed(2) + " y=" + vbY.toFixed(2) + " w=" + vbW.toFixed(2) + " h=" + vbH.toFixed(2));

      var bodyVb = "0 0 " + VIEWBOX_SIZE + " " + VIEWBOX_SIZE;
      var printMaskBodySvg =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' + bodyVb + '">' +
        '<path d="' + bodyPathD +
        '" fill="white" stroke="white" stroke-width="' + printStrokeW.toFixed(2) +
        '" stroke-linejoin="round" stroke-linecap="round" paint-order="stroke fill"/>' +
        "</svg>";

      var canvasRegionLeft = ((0 - vbX) / vbW) * 100;
      var canvasRegionTop = ((0 - vbY) / vbH) * 100;
      var canvasRegionWidth = (VIEWBOX_SIZE / vbW) * 100;
      var canvasRegionHeight = (VIEWBOX_SIZE / vbH) * 100;

      console.log("[ZUG][ACRYLIC_GEO] === CANVAS REGION (800→EVB wrapper) ===");
      console.log("[ZUG][ACRYLIC_GEO]   left=" + canvasRegionLeft.toFixed(4) + "% top=" + canvasRegionTop.toFixed(4) + "% w=" + canvasRegionWidth.toFixed(4) + "% h=" + canvasRegionHeight.toFixed(4) + "%");
      console.log("[ZUG][ACRYLIC_GEO]   wrapper aspect: " + (canvasRegionWidth / canvasRegionHeight).toFixed(6) + " (expect ~1.0 = " + VIEWBOX_SIZE + "x" + VIEWBOX_SIZE + " square)");
      console.log("[ZUG][ACRYLIC_GEO]   outer stack aspect: " + vbW.toFixed(2) + " / " + vbH.toFixed(2));

      return {
        fallback: false,
        hasTab: true,
        bodyPath: bodyPathD,
        tabMergedPath: outerPathD,
        printMaskUri: svgToDataUri(printMaskSvg),
        printMaskBodyUri: svgToDataUri(printMaskBodySvg),
        outerMaskUri: svgToDataUri(outerMaskSvg),
        outlineSvg: outlineSvg,
        debugOverlaySvg: debugOverlaySvg,
        aspectRatio: vbW.toFixed(2) + " / " + vbH.toFixed(2),
        bbox: bbox,
        printBbox: printBbox,
        cutBbox: cutBbox,
        outerBbox: outerBbox,
        holeAnchor: holeAnchor,
        borderVB: outerExpansionVB,
        printExpansionIn: printExpansionIn,
        clearBorderIn: clearBorderIn,
        outerExpansionIn: outerExpansionIn,
        printExpansionVB: printExpansionVB,
        outerExpansionVB: outerExpansionVB,
        vbPerInch: vbPerInch,
        physicalWidthIn: physicalWidthIn,
        physicalHeightIn: physicalHeightIn,
        uniformScale: { x: vbPerInch, y: vbPerInch },
        expandedViewBox: { x: vbX, y: vbY, width: vbW, height: vbH },
        canvasRegion: {
          left: canvasRegionLeft,
          top: canvasRegionTop,
          width: canvasRegionWidth,
          height: canvasRegionHeight,
        },
      };
    }

    var ringWidth = outlineWidth * 2.5;
    var rimHalfStroke = outerExpansionVB + ringWidth;
    var rimMinX = bbox.x - rimHalfStroke;
    var rimMinY = bbox.y - rimHalfStroke;
    var rimMaxX = bbox.x + bbox.width + rimHalfStroke;
    var rimMaxY = bbox.y + bbox.height + rimHalfStroke;
    var presentationPaddingVB = Math.max(
      0,
      -rimMinX,
      -rimMinY,
      rimMaxX - VIEWBOX_SIZE,
      rimMaxY - VIEWBOX_SIZE
    );
    if (presentationPaddingVB > 0) {
      presentationPaddingVB += Math.max(1, outlineWidth);
    }
    var vbX = -presentationPaddingVB;
    var vbY = -presentationPaddingVB;
    var vbW = VIEWBOX_SIZE + presentationPaddingVB * 2;
    var vbH = VIEWBOX_SIZE + presentationPaddingVB * 2;
    var vb =
      vbX.toFixed(2) +
      " " +
      vbY.toFixed(2) +
      " " +
      vbW.toFixed(2) +
      " " +
      vbH.toFixed(2);
    var bodyVb = "0 0 " + VIEWBOX_SIZE + " " + VIEWBOX_SIZE;

    var printMaskSvg =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' +
      vb +
      '">' +
      '<path d="' +
      bodyPathD +
      '" fill="white" stroke="white" stroke-width="' +
      printStrokeW.toFixed(2) +
      '" stroke-linejoin="round" stroke-linecap="round" paint-order="stroke fill"/>' +
      "</svg>";

    var outerMaskSvg =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' +
      vb +
      '">' +
      '<path d="' +
      bodyPathD +
      '" fill="white" stroke="white" stroke-width="' +
      outerStrokeW.toFixed(2) +
      '" stroke-linejoin="round" stroke-linecap="round" paint-order="stroke fill"/>' +
      "</svg>";

    var outlineSvg =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' +
      vb +
      '" style="width:100%;height:100%;display:block;overflow:visible;">' +
      '<defs><mask id="acr-ring" maskUnits="userSpaceOnUse" x="' +
      vbX.toFixed(2) +
      '" y="' +
      vbY.toFixed(2) +
      '" width="' +
      vbW.toFixed(2) +
      '" height="' +
      vbH.toFixed(2) +
      '">' +
      '<rect x="' +
      vbX.toFixed(2) +
      '" y="' +
      vbY.toFixed(2) +
      '" width="' +
      vbW.toFixed(2) +
      '" height="' +
      vbH.toFixed(2) +
      '" fill="white"/>' +
      '<path d="' +
      bodyPathD +
      '" fill="black" stroke="black" stroke-width="' +
      outerStrokeW.toFixed(2) +
      '" stroke-linejoin="round" stroke-linecap="round" paint-order="stroke fill"/>' +
      "</mask></defs>" +
      '<path d="' +
      bodyPathD +
      '" fill="none" stroke="rgba(109, 121, 135, ' +
      outlineOpacity.toFixed(2) +
      ')" stroke-width="' +
      (outerStrokeW + ringWidth * 2).toFixed(2) +
      '" stroke-linejoin="round" stroke-linecap="round" paint-order="stroke fill" mask="url(#acr-ring)"/>' +
      "</svg>";

    var printMaskBodySvg =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' +
      bodyVb +
      '">' +
      '<path d="' +
      bodyPathD +
      '" fill="white" stroke="white" stroke-width="' +
      printStrokeW.toFixed(2) +
      '" stroke-linejoin="round" stroke-linecap="round" paint-order="stroke fill"/>' +
      "</svg>";

    var canvasRegion = null;
    if (presentationPaddingVB > 0) {
      canvasRegion = {
        left: ((0 - vbX) / vbW) * 100,
        top: ((0 - vbY) / vbH) * 100,
        width: (VIEWBOX_SIZE / vbW) * 100,
        height: (VIEWBOX_SIZE / vbH) * 100,
      };
    }

    var outerBbox = {
      x: Math.max(0, bbox.x - outerExpansionVB),
      y: Math.max(0, bbox.y - outerExpansionVB),
      width:
        Math.min(VIEWBOX_SIZE, bbox.x + bbox.width + outerExpansionVB) -
        Math.max(0, bbox.x - outerExpansionVB),
      height:
        Math.min(VIEWBOX_SIZE, bbox.y + bbox.height + outerExpansionVB) -
        Math.max(0, bbox.y - outerExpansionVB),
    };

    var outerMinX = bbox.x - outerExpansionVB;
    var outerMinY = bbox.y - outerExpansionVB;
    var outerMaxX = bbox.x + bbox.width + outerExpansionVB;
    var outerMaxY = bbox.y + bbox.height + outerExpansionVB;
    var clipped =
      outerMinX < 0 ||
      outerMinY < 0 ||
      outerMaxX > VIEWBOX_SIZE ||
      outerMaxY > VIEWBOX_SIZE;

    console.log("[ZUG][ACRYLIC_GEO] === VALIDATION ===");
    console.log(
      "[ZUG][ACRYLIC_GEO] viewBox: " + vb + " (800-unit DCF canvas plus presentation-only rim padding)",
    );
    console.log(
      "[ZUG][ACRYLIC_GEO] bodyBbox: x=" +
        bbox.x.toFixed(1) +
        " y=" +
        bbox.y.toFixed(1) +
        " w=" +
        bbox.width.toFixed(1) +
        " h=" +
        bbox.height.toFixed(1),
    );
    console.log(
      "[ZUG][ACRYLIC_GEO] physical: " +
        physicalWidthIn.toFixed(3) +
        '" x ' +
        physicalHeightIn.toFixed(3) +
        '"',
    );
    console.log("[ZUG][ACRYLIC_GEO] vbPerInch: " + vbPerInch.toFixed(2) + " (width-only: " + bbox.width.toFixed(1) + " / " + physicalWidthIn.toFixed(3) + '")');
    console.log(
      "[ZUG][ACRYLIC_GEO] print: body + " +
        borderIn +
        '" = strokeW ' +
        printStrokeW.toFixed(2) +
        " VB (" +
        printExpansionVB.toFixed(2) +
        " per side)",
    );
    console.log(
      "[ZUG][ACRYLIC_GEO] outer: body + " +
        outerExpansionIn.toFixed(3) +
        '" (print expansion ' + printExpansionIn + ' + clear border ' + clearBorderIn + ') = strokeW ' +
        outerStrokeW.toFixed(2) +
        " VB (" +
        outerExpansionVB.toFixed(2) +
        " per side)",
    );
    console.log(
      "[ZUG][ACRYLIC_GEO] clear gap: " +
        gapIn +
        '" = ' +
        (outerExpansionVB - printExpansionVB).toFixed(2) +
        " VB per side",
    );
    console.log(
      "[ZUG][ACRYLIC_GEO] outer extends: (" +
        outerMinX.toFixed(1) +
        "," +
        outerMinY.toFixed(1) +
        ") to (" +
        outerMaxX.toFixed(1) +
        "," +
        outerMaxY.toFixed(1) +
      ")" +
        (clipped ? " ⚠ exceeds raw 800 boundary; padded viewBox applied" : " ✓ fits raw canvas"),
    );
    console.log("[ZUG][ACRYLIC_GEO] outerBbox: " + JSON.stringify(outerBbox));
    console.log(
      "[ZUG][ACRYLIC_GEO] rimBounds: (" +
        rimMinX.toFixed(1) +
        "," +
        rimMinY.toFixed(1) +
        ") to (" +
        rimMaxX.toFixed(1) +
        "," +
        rimMaxY.toFixed(1) +
        "), presentationPaddingVB=" +
        presentationPaddingVB.toFixed(2),
    );

    var debugOverlaySvg =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' + vb +
      '" style="width:100%;height:100%;display:block;overflow:visible;">' +
      '<path d="' + bodyPathD + '" fill="none" stroke="red" stroke-width="2" opacity="0.9"/>' +
      '<path d="' + bodyPathD + '" fill="none" stroke="green" stroke-width="' + printStrokeW.toFixed(2) + '" stroke-linejoin="round" stroke-linecap="round" paint-order="stroke fill" opacity="0.35"/>' +
      '<path d="' + bodyPathD + '" fill="none" stroke="blue" stroke-width="' + outerStrokeW.toFixed(2) + '" stroke-linejoin="round" stroke-linecap="round" paint-order="stroke fill" opacity="0.2"/>' +
      '<rect x="' + bbox.x.toFixed(2) + '" y="' + bbox.y.toFixed(2) + '" width="' + bbox.width.toFixed(2) + '" height="' + bbox.height.toFixed(2) + '" fill="none" stroke="red" stroke-width="1" stroke-dasharray="4,2" opacity="0.6"/>' +
      '<circle cx="' + (bbox.x + bbox.width / 2).toFixed(2) + '" cy="' + (bbox.y + bbox.height / 2).toFixed(2) + '" r="4" fill="red" opacity="0.7"/>' +
      '</svg>';

    var printExpandedBbox = printBbox;

    console.log("[ZUG][ACRYLIC_GEO] === DEBUG BOUNDS ===");
    console.log("[ZUG][ACRYLIC_GEO] bodyPath (red):  x=" + bbox.x.toFixed(2) + " y=" + bbox.y.toFixed(2) + " w=" + bbox.width.toFixed(2) + " h=" + bbox.height.toFixed(2) + " cx=" + (bbox.x + bbox.width / 2).toFixed(2) + " cy=" + (bbox.y + bbox.height / 2).toFixed(2));
    console.log("[ZUG][ACRYLIC_GEO] printPath (green): x=" + printExpandedBbox.x.toFixed(2) + " y=" + printExpandedBbox.y.toFixed(2) + " w=" + printExpandedBbox.width.toFixed(2) + " h=" + printExpandedBbox.height.toFixed(2) + " cx=" + (printExpandedBbox.x + printExpandedBbox.width / 2).toFixed(2) + " cy=" + (printExpandedBbox.y + printExpandedBbox.height / 2).toFixed(2));
    console.log("[ZUG][ACRYLIC_GEO] outerPath (blue): x=" + outerBbox.x.toFixed(2) + " y=" + outerBbox.y.toFixed(2) + " w=" + outerBbox.width.toFixed(2) + " h=" + outerBbox.height.toFixed(2) + " cx=" + (outerBbox.x + outerBbox.width / 2).toFixed(2) + " cy=" + (outerBbox.y + outerBbox.height / 2).toFixed(2));

    return {
      fallback: false,
      hasTab: false,
      bodyPath: bodyPathD,
      printMaskUri: svgToDataUri(printMaskSvg),
      printMaskBodyUri: svgToDataUri(printMaskBodySvg),
      outerMaskUri: svgToDataUri(outerMaskSvg),
      outlineSvg: outlineSvg,
      debugOverlaySvg: debugOverlaySvg,
      aspectRatio: vbW.toFixed(2) + " / " + vbH.toFixed(2),
      bbox: bbox,
      printBbox: printBbox,
      cutBbox: cutBbox,
      outerBbox: outerBbox,
      borderVB: outerExpansionVB,
      printExpansionIn: printExpansionIn,
      clearBorderIn: clearBorderIn,
      outerExpansionIn: outerExpansionIn,
      printExpansionVB: printExpansionVB,
      outerExpansionVB: outerExpansionVB,
      vbPerInch: vbPerInch,
      physicalWidthIn: physicalWidthIn,
      physicalHeightIn: physicalHeightIn,
      uniformScale: { x: vbPerInch, y: vbPerInch },
      expandedViewBox: { x: vbX, y: vbY, width: vbW, height: vbH },
      canvasRegion: canvasRegion,
      presentationPaddingVB: presentationPaddingVB,
      visualBounds: {
        x: rimMinX,
        y: rimMinY,
        width: rimMaxX - rimMinX,
        height: rimMaxY - rimMinY,
      },
    };
  }

  window.ZugAcrylicGeometry = {
    generateShapes: generateShapes,
    pathBBox: pathBBox,
    svgToDataUri: svgToDataUri,
    ensurePaper: ensurePaper,
  };
})();
